let temporalUiBase = import.meta.env.VITE_TEMPORAL_UI_BASE || "";

/** Apply public runtime app config after /auth-config.json is loaded. */
export function configureTemporalUiBase(value: string): void {
  temporalUiBase = value.trim();
}

/** Runtime temporal-gate origin; empty means workflow links stay disabled. */
export function getTemporalUiBase(): string {
  return temporalUiBase;
}
